import React from "react";
import * as S from "sanctuary";

import { getAmountByStatus } from "@/components/payment/payment.util";
import { PAYMENT_STATUSES } from "@/sanctuary/typedefs";
import Tooltip from "@/components/generic/Tooltip";

import { Box, Cluster, Text } from "@thecb/components";

import { BACKGROUND_GREY } from "@/constants/colors";
import { SEMI_BOLD } from "@/constants/fonts";

const mapTooltipText = {
  [PAYMENT_STATUSES.REFUNDED]: "This transaction has been refunded",
  [PAYMENT_STATUSES.CHARGEBACK]: "This transaction has a chargeback",
  [PAYMENT_STATUSES.CHARGEBACK_REVERSAL]: "This chargeback has been reversed",
  [PAYMENT_STATUSES.ACH_RETURN]: "This transaction has an ACH return",
};

export default ({ payment }) => {
  const id = S.fromMaybe("")(S.map(S.show)(payment.id));
  const status = S.fromEither("")(S.fromMaybe(S.Right(""))(payment.status));
  const totalAmount = S.fromMaybe("")(payment.totalAmount);
  const originalPaymentId = S.fromMaybe(0)(payment.originalPaymentId);
  const associatedPayment = S.find((element) =>
    S.isJust(
      S.find(S.equals(S.fromMaybe("")(element.status)))(Object.keys(mapTooltipText))
    )
  )(payment.associatedPayments);
  const showTooltip =
    S.isJust(associatedPayment) &&
    S.not(S.equals(status)(PAYMENT_STATUSES.CHARGEBACK_REVERSAL));
  return (
    <Box padding="1.5rem" background={BACKGROUND_GREY}>
      <Cluster overflow justify="space-between" align="center">
        <Box padding="0" dataQa="Transaction ID" extraStyles="display: flex;">
          <Text variant="pL" extraStyles={`font-size: 1.25rem;`}>
            Transaction ID:{" "}
            <Text
              variant="pL"
              weight={SEMI_BOLD}
              extraStyles={`font-size: 1.25rem;`}
            >
              {id}
            </Text>
          </Text>

          {showTooltip && (
            <Box
              padding="0 0 0 8px"
              extraStyles="display: inline-flex; align-items: center;"
            >
              <Tooltip
                variant="info"
                right
                text={
                  mapTooltipText[S.fromMaybe("")(associatedPayment.value.status)]
                }
              />
            </Box>
          )}
        </Box>
        <Text variant="pL" weight={SEMI_BOLD} extraStyles={`font-size: 1.25rem;`}>
          {getAmountByStatus(totalAmount, status, originalPaymentId)}
        </Text>
      </Cluster>
    </Box>
  );
};
